export const putgasStepStyles = (theme) => ({
  downloadLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  marginRight: {
    marginRight: 4,
  },
  marginRightContainer: {
    marginRight: 48,
  },
})
